webpackJsonp([11],{

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(865)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(868),
  /* template */
  __webpack_require__(870),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 498:
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.detectUa = function () {
    var browers = {};
    var ua = navigator.userAgent.toLowerCase();
    browers.iPad = ua.match(/ipad/);
    browers.iPhone = ua.match(/iphone/);
    browers.isAndroid = ua.match(/android/);
    browers.isiOS = ua.match(/ipad|iphone|ios/);
    browers.isDesktop = !browers.isiOS && !browers.isAndroid;
    browers.ie = ua.match(/iemobile/);
    browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
    browers.force_ssl = ua.match(/Android (5|6)/i);
    browers.is_ios_6 = ua.match(/iOS 6/i);
    browers.is_liveapp = ua.match(/LiveApp/i);
    return browers;
};

exports.jumpUrl = function (is_apk) {
    ga('send', 'event', 'app', 'download', location.pathname, 1);
    var isiOS = navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone') || navigator.userAgent.match('iPod'),
        isAndroid = navigator.userAgent.match('Android'),
        isDesktop = !isiOS && !isAndroid;
    function getCookie(name) {
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    }
    function jumpDownload(android_url, ios_url) {
        if (isAndroid) {
            location.href = android_url;
        } else if (isiOS) {
            location.href = ios_url;
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadCom(android_url, ios_url) {
        if (isAndroid) {
            var apk = location.href = '/download';
            var google_play = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
            adroidDownload(apk, google_play);
        } else if (isiOS) {
            location.href = 'https://go.onelink.me/app/ff33e3d5';
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadPopup() {
        if (isAndroid) {
            return '/download';
        } else if (isiOS) {
            return 'https://go.onelink.me/1751978436?pid=M_FB';
        } else if (isDesktop) {
            return 'http://www.allfootballapp.com/home';
        }
    }

    function adroidDownload(apk, google_play) {
        console.log('随机方法');
        if (Math.random() >= 0.5) {
            location.href = apk;
        } else {
            location.href = google_play;
        }
    }
    var goog_snippet_vars = function goog_snippet_vars() {
        var w = window;
        w.google_conversion_id = 838643918;
        w.google_conversion_label = 'ds1fCN_xrHkQzuHyjwM';
        w.google_remarketing_only = false;
    };

    function goog_report_conversion(url) {
        var isOperaMini = navigator.userAgent.indexOf('Opera Mini');
        console.log('isOperaMini', isOperaMini);
        goog_snippet_vars();
        window.google_conversion_format = '3';
        var opt = new Object();
        opt.onload_callback = function () {
            if (typeof url !== 'undefined') {
                console.log('url2', url);
                if (isAndroid) {
                    window.location = 'market://details?id=com.allfootball.news';
                    setTimeout(function () {
                        console.log('跳转GP失败');
                        window.location = url;
                    }, 1000);
                    return;
                }
                window.location = url;
            }
        };
        var conv_handler = window['google_trackConversion'];
        if (typeof conv_handler === 'function') {
            if (isOperaMini >= 0) {
                console.log('url', url);
                window.location = url;
            } else {
                conv_handler(opt);
            }
        }
    }
    var utm_source = getCookie('utm_source');
    var utm_campaign = getCookie('utm_campaign');
    var search = (location.search || '').slice(1);
    if (utm_source === 'google_search' && utm_campaign === 'EPL') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'La Liga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Bundesliga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Serie A') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Transfers') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'UC-Browser' && utm_campaign === 'p20') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (location.pathname === '/downloadCoin' || search.indexOf('utm_source=shareForAFCoin') > -1 || utm_source === 'shareForAFCoin') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else {
        if (is_apk) {
            if (location.hostname === 'm.all.football') {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            } else {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            }
        } else {
            var url = jumpDownloadPopup();
            console.log('ios的url', url);
            location.href = url;
            goog_report_conversion(url);
        }
    }
};

exports.lazyload = function (id, classImg) {
    var listwrap = document.getElementById(id);
    if (listwrap) {
        var teamLogo = document.getElementsByClassName(classImg);
        var windowH = window.innerHeight;
        var offsetY = window.pageYOffset;
        for (var i = 0; i < teamLogo.length; i++) {
            var iT = teamLogo[i].getBoundingClientRect().top;
            if (iT < windowH + offsetY + windowH * 3 / 4) {
                if (teamLogo[i].getAttribute('data-src')) {
                    teamLogo[i].src = teamLogo[i].getAttribute('data-src');
                    teamLogo[i].removeAttribute('data-src');
                }
            }
        }
    }
};

exports.timeForInOut = function () {};

exports.checkOperamini = function () {
    var isOperaMini = navigator.userAgent.indexOf('Opera Mini') > -1;
    return isOperaMini;
};

exports.record = function (url) {
    var prefix = '//stat.allfootballapp.com';
    var newImage = new Image();
    newImage.src = prefix + '/' + url;
    return newImage;
};

exports.getQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
};

/***/ }),

/***/ 631:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAyCAMAAADGIxO9AAAAgVBMVEUAAAA1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTXe3t7y8vL///9ZWVns7OyYmJj4+Ph0dHQ6OjpycnJQUFD39/fn5+eTk5N+fn6am3M3AAAAG3RSTlMABNnMpfPwRAjmmC4hAtTQozo+6uR6ZF5DeXuvW6jRAAABcUlEQVRIx63W6XKCMBQFYCGBAILggksPiNbW7f0fsNFhEsnC2vPTmW8wyc3Nnf1PnOWBktCHHxKar5xukLDMw2e8jCXtn9gtoGexa/nYSghVrSwiiGBPFJhInKItaayTeYj2hHON+OiKr6B4je5s4sbyU/RJGnyYCP0SSbJH3+zF6bu9jevUZov+2dZl6Q4wbvI2DI1U5ytEfp6/CmJvkzXJvSwqQc6nu4Ky9w4078u5PHIkyPFWNI3ncLNEI9dCoBf5LtQ/t+QmV36ralSTC5QcuKEwIwsB5YbAjCwEhJs1zMhCsOEGMCMLga8Zucliy9XoRmxyaUGeWI9GikIgfT3ETC6VBRH9fORRWhDlJrcQG8r1envWRCK13vS6vpxuLyJQ+VDrWt4fiV6VLNHjqt0fHoYhYWP6wYi+M6a/De+jbFK/ngWkFyHBiPdnxDs36j2d/m53zwdT5hB93nENwt05HXMVVeYqypJh89vX3rCOP6iAyB6E7ftMAAAAAElFTkSuQmCC"

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.a9ed8cc.png";

/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(866);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("8a183ec0", content, true, {});

/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(498);
exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "body .lx-load-box{width:4rem;height:4rem;min-height:0;margin-left:-2rem;top:220px}.fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}.overlay{position:fixed;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,.4)}.overlay .close{position:absolute;top:-.3rem;right:-.3rem;width:1.5rem;height:1.5rem}.overlay .modal{width:84%;height:10rem;text-align:center;background:#fff;margin:auto;position:absolute;top:0;bottom:0;left:0;right:0;border-radius:4px}.overlay .modal .content{padding:1.375rem;font-size:1rem;background:#f7f7f7;line-height:1.5;font-weight:700;border-radius:4px 4px 0 0;min-height:2.8rem;white-space:pre-line}.overlay .modal .content b{color:#24af41}.overlay .modal .download{padding:1rem 1.25rem;text-align:left;background:#fff;border-radius:0 0 4px 4px}.overlay .modal h2{font-size:1.2rem}.overlay .modal .star{background:url(" + escape(__webpack_require__(867)) + ") no-repeat;background-size:100%;display:inline-block;vertical-align:top;width:.8rem;height:.8rem}.overlay .modal .logo{width:2.37rem;line-height:1;font-size:0;float:left;margin-right:.5rem}.overlay .modal .btns{float:right;padding:.26rem 0}.overlay .modal .btns button{background:#24af41;color:#fff;height:1.75rem;line-height:1.75rem;width:5.5rem;text-align:center;border:none;-webkit-appearance:none;border-radius:2px}.overlay .modal .btns img{width:1rem;height:1rem;margin-left:.26rem;margin-right:-.26rem;position:relative;top:.15rem}.live-wrap{color:#111;font-family:Source Han Sans,Arial,Helvetica Neue,Helvetica,sans-serif}header h1{height:2.92rem;background:#24af41;color:#fff;font-size:1rem;line-height:2.92rem;text-align:center}ul{padding-bottom:4rem}ul.without-banner{padding-bottom:0}li{list-style:none;border-bottom:1px solid #eee;clear:both}li.top,li:last-child{border:none}li.top{background:#fffcdc}.away,.home{float:left;width:6.875rem;overflow:hidden;text-align:center;padding:1.25rem 0}.away img,.home img{width:2.375rem}.away p,.home p{font-size:.8em;line-height:1.1}.away{float:right}.status{height:6rem;text-align:center;box-sizing:border-box}.status .competition{font-size:.8em;padding:1.18rem 0 0;color:#999;line-height:1.2}.status .time{font-size:1rem;line-height:2.2}.status .minute{padding-top:1rem;color:#24af41;font-size:.8rem;line-height:1}.status .score{font-size:1.5rem;color:#24af41;letter-spacing:.4rem;text-indent:.2rem}.status label{width:5.5rem;height:1.25rem;color:#fff;display:inline-block;background:#24af41;font-size:.8rem;line-height:1.25rem;border-radius:2px;margin-top:.4rem}footer{position:fixed;width:100%;background:#fff;bottom:0;padding:.75rem 1.25rem;box-shadow:0 0 6px rgba(0,0,0,.2);box-sizing:border-box}footer h2{font-size:1.2rem}footer span{font-size:.8rem;color:#999}footer .logo{width:2.37rem;line-height:1;font-size:0;float:left;margin-right:.5rem}footer .close-wrap{display:inline-block;height:1.45rem;vertical-align:top;width:1.75rem;margin-right:-1rem;padding-top:.3rem}footer .btns{float:right;padding:.26rem 0}footer .btns button{background:#24af41;color:#fff;height:1.75rem;line-height:1.75rem;width:5.5rem;text-align:center;border:none;-webkit-appearance:none;border-radius:2px}footer .btns img{width:1rem;height:1rem;margin-left:.26rem;margin-right:-.26rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/pages/AppLiveList.vue"],"names":[],"mappings":"AACA,kBACE,WAAY,AACZ,YAAa,AACb,aAAc,AACd,kBAAmB,AACnB,SAAW,CACZ,AACD,sCAEE,sBAAwB,CACzB,AACD,2BAEE,SAAW,CACZ,AACD,SACE,eAAgB,AAChB,MAAO,AACP,SAAU,AACV,OAAQ,AACR,QAAS,AACT,yBAA+B,CAChC,AACD,gBACE,kBAAmB,AACnB,WAAa,AACb,aAAe,AACf,aAAc,AACd,aAAe,CAChB,AACD,gBACE,UAAW,AACX,aAAc,AACd,kBAAmB,AACnB,gBAAiB,AACjB,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,SAAU,AACV,OAAQ,AACR,QAAS,AACT,iBAAmB,CACpB,AACD,yBACE,iBAAkB,AAClB,eAAgB,AAChB,mBAAoB,AACpB,gBAAiB,AACjB,gBAAkB,AAClB,0BAA2B,AAC3B,kBAAmB,AACnB,oBAAsB,CACvB,AACD,2BACE,aAAe,CAChB,AACD,0BACE,qBAAsB,AACtB,gBAAiB,AACjB,gBAAiB,AACjB,yBAA2B,CAC5B,AACD,mBACE,gBAAkB,CACnB,AACD,sBACE,mDAA8C,AAC9C,qBAAsB,AACtB,qBAAsB,AACtB,mBAAoB,AACpB,YAAc,AACd,YAAe,CAChB,AACD,sBACE,cAAe,AACf,cAAe,AACf,YAAa,AACb,WAAY,AACZ,kBAAqB,CACtB,AACD,sBACE,YAAa,AACb,gBAAmB,CACpB,AACD,6BACE,mBAAoB,AACpB,WAAY,AACZ,eAAgB,AAChB,oBAAqB,AACrB,aAAc,AACd,kBAAmB,AACnB,YAAa,AACb,wBAAyB,AACzB,iBAAmB,CACpB,AACD,0BACE,WAAY,AACZ,YAAa,AACb,mBAAqB,AACrB,qBAAuB,AACvB,kBAAmB,AACnB,UAAa,CACd,AACD,WACE,WAAY,AACZ,qEAA+E,CAChF,AACD,UACE,eAAgB,AAChB,mBAAoB,AACpB,WAAY,AACZ,eAAgB,AAChB,oBAAqB,AACrB,iBAAmB,CACpB,AACD,GACE,mBAAqB,CACtB,AACD,kBACE,gBAAqB,CACtB,AACD,GACE,gBAAiB,AACjB,6BAA8B,AAC9B,UAAY,CACb,AAID,qBAFE,WAAa,CAKd,AAHD,OACE,kBAAoB,CAErB,AACD,YAEE,WAAY,AACZ,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,oBAEE,cAAgB,CACjB,AACD,gBAEE,eAAiB,AACjB,eAAiB,CAClB,AACD,MACE,WAAa,CACd,AACD,QACE,YAAa,AACb,kBAAmB,AACnB,qBAAuB,CACxB,AACD,qBACE,eAAiB,AACjB,oBAAqB,AACrB,WAAY,AACZ,eAAiB,CAClB,AACD,cACE,eAAgB,AAChB,eAAiB,CAClB,AACD,gBACE,iBAAkB,AAClB,cAAe,AACf,gBAAkB,AAClB,aAAe,CAChB,AACD,eACE,iBAAkB,AAClB,cAAe,AACf,qBAAuB,AACvB,iBAAoB,CACrB,AACD,cACE,aAAc,AACd,eAAgB,AAChB,WAAY,AACZ,qBAAsB,AACtB,mBAAoB,AACpB,gBAAkB,AAClB,oBAAqB,AACrB,kBAAmB,AACnB,gBAAmB,CACpB,AACD,OACE,eAAgB,AAChB,WAAY,AACZ,gBAAiB,AACjB,SAAU,AACV,uBAAyB,AACzB,kCAAuC,AACvC,qBAAuB,CACxB,AACD,UACE,gBAAkB,CACnB,AACD,YACE,gBAAkB,AAClB,UAAY,CACb,AACD,aACE,cAAe,AACf,cAAe,AACf,YAAa,AACb,WAAY,AACZ,kBAAqB,CACtB,AACD,mBACE,qBAAsB,AACtB,eAAgB,AAChB,mBAAoB,AACpB,cAAe,AACf,mBAAoB,AACpB,iBAAoB,CACrB,AACD,aACE,YAAa,AACb,gBAAmB,CACpB,AACD,oBACE,mBAAoB,AACpB,WAAY,AACZ,eAAgB,AAChB,oBAAqB,AACrB,aAAc,AACd,kBAAmB,AACnB,YAAa,AACb,wBAAyB,AACzB,iBAAmB,CACpB,AACD,iBACE,WAAY,AACZ,YAAa,AACb,mBAAqB,AACrB,oBAAuB,CACxB","file":"AppLiveList.vue","sourcesContent":["\nbody .lx-load-box {\n  width: 4rem;\n  height: 4rem;\n  min-height: 0;\n  margin-left: -2rem;\n  top: 220px;\n}\n.fade-enter-active,\n.fade-leave-active {\n  transition: opacity .5s;\n}\n.fade-enter,\n.fade-leave-to {\n  opacity: 0;\n}\n.overlay {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.4);\n}\n.overlay .close {\n  position: absolute;\n  top: -0.3rem;\n  right: -0.3rem;\n  width: 1.5rem;\n  height: 1.5rem;\n}\n.overlay .modal {\n  width: 84%;\n  height: 10rem;\n  text-align: center;\n  background: #fff;\n  margin: auto;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  border-radius: 4px;\n}\n.overlay .modal .content {\n  padding: 1.375rem;\n  font-size: 1rem;\n  background: #f7f7f7;\n  line-height: 1.5;\n  font-weight: bold;\n  border-radius: 4px 4px 0 0;\n  min-height: 2.8rem;\n  white-space: pre-line;\n}\n.overlay .modal .content b {\n  color: #24af41;\n}\n.overlay .modal .download {\n  padding: 1rem 1.25rem;\n  text-align: left;\n  background: #fff;\n  border-radius: 0 0 4px 4px;\n}\n.overlay .modal h2 {\n  font-size: 1.2rem;\n}\n.overlay .modal .star {\n  background: url(../assets/star.png) no-repeat;\n  background-size: 100%;\n  display: inline-block;\n  vertical-align: top;\n  width: 0.8rem;\n  height: 0.8rem;\n}\n.overlay .modal .logo {\n  width: 2.37rem;\n  line-height: 1;\n  font-size: 0;\n  float: left;\n  margin-right: 0.5rem;\n}\n.overlay .modal .btns {\n  float: right;\n  padding: 0.26rem 0;\n}\n.overlay .modal .btns button {\n  background: #24af41;\n  color: #fff;\n  height: 1.75rem;\n  line-height: 1.75rem;\n  width: 5.5rem;\n  text-align: center;\n  border: none;\n  -webkit-appearance: none;\n  border-radius: 2px;\n}\n.overlay .modal .btns img {\n  width: 1rem;\n  height: 1rem;\n  margin-left: 0.26rem;\n  margin-right: -0.26rem;\n  position: relative;\n  top: 0.15rem;\n}\n.live-wrap {\n  color: #111;\n  font-family: 'Source Han Sans', Arial, \"Helvetica Neue\", Helvetica, sans-serif;\n}\nheader h1 {\n  height: 2.92rem;\n  background: #24af41;\n  color: #fff;\n  font-size: 1rem;\n  line-height: 2.92rem;\n  text-align: center;\n}\nul {\n  padding-bottom: 4rem;\n}\nul.without-banner {\n  padding-bottom: 0rem;\n}\nli {\n  list-style: none;\n  border-bottom: 1px solid #eee;\n  clear: both;\n}\nli:last-child {\n  border: none;\n}\nli.top {\n  background: #fffcdc;\n  border: none;\n}\n.home,\n.away {\n  float: left;\n  width: 6.875rem;\n  overflow: hidden;\n  text-align: center;\n  padding: 1.25rem 0;\n}\n.home img,\n.away img {\n  width: 2.375rem;\n}\n.home p,\n.away p {\n  font-size: 0.8em;\n  line-height: 1.1;\n}\n.away {\n  float: right;\n}\n.status {\n  height: 6rem;\n  text-align: center;\n  box-sizing: border-box;\n}\n.status .competition {\n  font-size: 0.8em;\n  padding: 1.18rem 0 0;\n  color: #999;\n  line-height: 1.2;\n}\n.status .time {\n  font-size: 1rem;\n  line-height: 2.2;\n}\n.status .minute {\n  padding-top: 1rem;\n  color: #24af41;\n  font-size: 0.8rem;\n  line-height: 1;\n}\n.status .score {\n  font-size: 1.5rem;\n  color: #24af41;\n  letter-spacing: 0.4rem;\n  text-indent: 0.2rem;\n}\n.status label {\n  width: 5.5rem;\n  height: 1.25rem;\n  color: #fff;\n  display: inline-block;\n  background: #24af41;\n  font-size: 0.8rem;\n  line-height: 1.25rem;\n  border-radius: 2px;\n  margin-top: 0.4rem;\n}\nfooter {\n  position: fixed;\n  width: 100%;\n  background: #fff;\n  bottom: 0;\n  padding: 0.75rem 1.25rem;\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);\n  box-sizing: border-box;\n}\nfooter h2 {\n  font-size: 1.2rem;\n}\nfooter span {\n  font-size: 0.8rem;\n  color: #999;\n}\nfooter .logo {\n  width: 2.37rem;\n  line-height: 1;\n  font-size: 0;\n  float: left;\n  margin-right: 0.5rem;\n}\nfooter .close-wrap {\n  display: inline-block;\n  height: 1.45rem;\n  vertical-align: top;\n  width: 1.75rem;\n  margin-right: -1rem;\n  padding-top: 0.3rem;\n}\nfooter .btns {\n  float: right;\n  padding: 0.26rem 0;\n}\nfooter .btns button {\n  background: #24af41;\n  color: #fff;\n  height: 1.75rem;\n  line-height: 1.75rem;\n  width: 5.5rem;\n  text-align: center;\n  border: none;\n  -webkit-appearance: none;\n  border-radius: 2px;\n}\nfooter .btns img {\n  width: 1rem;\n  height: 1rem;\n  margin-left: 0.26rem;\n  margin-right: -0.26rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 867:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAbBAMAAACQOIJYAAAAMFBMVEUAAAD3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSv3nSu2a2yBAAAAD3RSTlMAdxHM7qqIMyLdRJlmVbvFUNfrAAAApUlEQVQY02OAACYGZFCLwstG4U1B5nD8v4DEY/wfgMRj/v8Jidf//w8ST/7/VySe/f//CmCGIAj8//9/I4hmKP6PAB8ZGPLhnJ8FDAxc/jBeEEinKpTjAzMfBD43QHjsYF4A3M0gsAHuZhBwgLsZBH7B3fzf7f//bwg3K6z8/xPKe/9FgIEp/n8BJPT+W4CM8hcA83g+gqliAzDFtgCiIQkWzjAaAF4EaHkAGJXiAAAAAElFTkSuQmCC"

/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(197);

var _assign2 = _interopRequireDefault(_assign);

var _axios = __webpack_require__(185);

var _axios2 = _interopRequireDefault(_axios);

var _util = __webpack_require__(499);

__webpack_require__(869);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            footerShow: true,
            modalShow: false,
            listClicked: false,
            iOSUrl: '',
            androidUrl: '',
            alertText: '20 juta orang menggunakan Aplikasi \nAll Sepakbola App.',
            list: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        var utm_source = this.$route.query['from'] || this.$route.query['utm_source'];
        this.$loading('loading');
        _axios2.default.get(global.apiDomain + '/m/data/sem/match?utm_source=' + utm_source).then(function (res) {
            var data = res.data;
            if (data.errno) {
                _this.$toast(data.errmsg);
                return;
            }

            _this.$loading.close();

            (0, _assign2.default)(_this, data.data);

            _this.list.sort(function (a, b) {
                if (a.is_top && !b.is_top) {
                    return -1;
                }
                if (!a.is_top && b.is_top) {
                    return 1;
                }
                return 0;
            });
            _this.modalShow = true;
        }, function (res) {});
    },

    methods: {
        formatData: function formatData(gmtDate) {
            var date = new Date(gmtDate.replace(/-/g, '/')).getTime();
            var diffMin = new Date().getTimezoneOffset();
            var localDate = new Date(date - diffMin * 60 * 1000);

            var prefixZero = function prefixZero(s) {
                return ('0' + s).slice(-2);
            };
            var day = [prefixZero(localDate.getMonth() + 1), prefixZero(localDate.getDate())].join('-');
            var time = [prefixZero(localDate.getHours()), prefixZero(localDate.getMinutes())].join(':');

            return [day, time].join(' ');
        },
        showDialog: function showDialog() {
            this.modalShow = true;
            this.listClicked = true;
            ga('send', 'event', 'sem', 'modalshow');
        },
        download: function download() {
            var browser = (0, _util.detectUa)();

            if (browser.isAndroid) {
                location.href = this.androidUrl;
            } else {
                location.href = this.iOSUrl;
            }
        },
        downloadModal: function downloadModal() {
            ga('send', 'event', 'sem', 'download', 'modal', this.listClicked);
            this.download();
        },
        downloadFooter: function downloadFooter() {
            ga('send', 'event', 'sem', 'download', 'footer');
            this.download();
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(200);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
__webpack_require__(204);
__webpack_require__(205);
__webpack_require__(206);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(209);
__webpack_require__(210);
__webpack_require__(211);
__webpack_require__(212);
__webpack_require__(213);
__webpack_require__(214);
__webpack_require__(215);
__webpack_require__(216);
__webpack_require__(217);
__webpack_require__(218);
__webpack_require__(219);
__webpack_require__(220);
__webpack_require__(221);
__webpack_require__(222);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(225);
__webpack_require__(226);
__webpack_require__(227);
__webpack_require__(228);
__webpack_require__(229);
__webpack_require__(230);
__webpack_require__(231);
__webpack_require__(232);
__webpack_require__(233);
__webpack_require__(234);
__webpack_require__(235);
__webpack_require__(236);
__webpack_require__(237);
__webpack_require__(238);
__webpack_require__(239);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(242);
__webpack_require__(243);
__webpack_require__(244);
__webpack_require__(245);
__webpack_require__(246);
__webpack_require__(247);
__webpack_require__(248);
__webpack_require__(249);
__webpack_require__(250);
__webpack_require__(251);
__webpack_require__(252);
__webpack_require__(253);
__webpack_require__(254);
__webpack_require__(255);
__webpack_require__(256);
__webpack_require__(257);
__webpack_require__(258);
__webpack_require__(259);
__webpack_require__(260);
__webpack_require__(261);
__webpack_require__(262);
__webpack_require__(263);
__webpack_require__(264);
__webpack_require__(265);
__webpack_require__(266);
__webpack_require__(267);
__webpack_require__(268);
__webpack_require__(269);
__webpack_require__(270);
__webpack_require__(271);
__webpack_require__(272);
__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(276);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(280);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(92);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(133);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(134);
__webpack_require__(135);
__webpack_require__(136);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
module.exports = __webpack_require__(24);


/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    class: {
      'without-banner': !_vm.footerShow
    }
  }, _vm._l((_vm.list), function(match) {
    return _c('li', {
      key: match.match_id,
      class: {
        top: match.is_top
      },
      on: {
        "click": function($event) {
          _vm.showDialog()
        }
      }
    }, [_c('div', {
      staticClass: "home"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgSrc(match.team_A_logo),
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(match.team_A_name))])]), _vm._v(" "), _c('div', {
      staticClass: "away"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgSrc(match.team_B_logo),
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(match.team_B_name))])]), _vm._v(" "), (match.status !== 'Playing') ? _c('div', {
      staticClass: "status"
    }, [_c('p', {
      staticClass: "competition"
    }, [_vm._v(_vm._s(match.competition_name))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.formatData(match.start_play)))])]) : _vm._e(), _vm._v(" "), (match.status === 'Playing') ? _c('div', {
      staticClass: "status"
    }, [_c('p', {
      staticClass: "minute"
    }, [_vm._v(_vm._s(match.minute) + "'")]), _vm._v(" "), _c('p', {
      staticClass: "score"
    }, [_vm._v(_vm._s(match.team_A_score) + " - " + _vm._s(match.team_B_score))]), _vm._v(" "), _c('label', {
      attrs: {
        "for": "score"
      }
    }, [_vm._v("Skor Langsung")])]) : _vm._e()])
  })), _vm._v(" "), (_vm.footerShow) ? _c('footer', {
    on: {
      "click": function($event) {
        _vm.downloadFooter()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('button', [_vm._v("Dapatkan Gratis")]), _vm._v(" "), _c('span', {
    staticClass: "close-wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.footerShow = false
      }
    }
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": __webpack_require__(631),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('h2', [_vm._v("All Sepakbola")]), _vm._v(" "), _c('span', [_vm._v("Semua Skor Sepak Bola Terbaru")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.modalShow) ? _c('div', {
    staticClass: "overlay",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "modal",
    on: {
      "click": function($event) {
        _vm.downloadModal()
      }
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.modalShow = false
      }
    }
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": __webpack_require__(631),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.alertText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(632),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('button', [_vm._v("Get it Free")])]), _vm._v(" "), _c('h2', [_vm._v("All Sepakbola")]), _vm._v(" "), _c('span', {
    staticClass: "star"
  }), _vm._v(" "), _c('span', {
    staticClass: "star"
  }), _vm._v(" "), _c('span', {
    staticClass: "star"
  }), _vm._v(" "), _c('span', {
    staticClass: "star"
  }), _vm._v(" "), _c('span', {
    staticClass: "star"
  })])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Tonton Sepak Bola - Live Sepak Bola Gratis")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(632),
      "alt": ""
    }
  })])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.0bd12ac6b60bdedac604.js